import {
  PersonalSpaceStateProps,
  PersonalSpaceDispatchProps,
  PersonalSpaceOwnProps,
  PersonalSpace
} from './PersonalSpace';
import { AppState } from '../../state/AppState';
import { MapStateToProps, MapDispatchToProps } from '../../utils/ConnectUtils';
import { selectCurrentlyApplicableContentTypes, selectDefaultContentTypeFilterValues } from '../../selectors/ContentFilterSelectors';
import { siteUrlsSelector } from '../../selectors/SiteUrlsSelectors';
import { showContentTypes } from '../../actions/spaces/ContentExplorerFilterActions';
import { requestSpaceContents } from '../../actions/spaces/RequestSpaceContentsActions';
import { clearSpaceContentCountsAction } from '../../actions/spaces/ContentCountsActions';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { errorBoundary, sendTelemetryErrorEvent } from '../../../common/react/components/ErrorBoundary';
import { getPersonalSpace } from '../../../personalSpace/actions/PersonalSpaceActions';
import { selectPersonalSpace } from '../../../personalSpace/selectors/PersonalSpaceSelector';

const mapStateToProps: MapStateToProps<PersonalSpaceStateProps> = (state: AppState) => ({
  contentTypeFilterValues: selectCurrentlyApplicableContentTypes(state),
  defaultContentTypeFilterValues: selectDefaultContentTypeFilterValues(state),
  urls: siteUrlsSelector(state),
  personalSpace: selectPersonalSpace(state)
});

const mapDispatchToProps: MapDispatchToProps<PersonalSpaceDispatchProps> = (dispatch) =>
  bindActionCreators({
    filterSelected: showContentTypes,
    requestSpaceContents,
    clearContentCounts: clearSpaceContentCountsAction,
    getPersonalSpace
  }, dispatch);

const ConnectedPersonalSpaceInternal: React.ComponentClass<PersonalSpaceOwnProps>
  = connect(mapStateToProps, mapDispatchToProps)(PersonalSpace);

export const ConnectedPersonalSpace =
  errorBoundary<PersonalSpaceOwnProps>
    (sendTelemetryErrorEvent)(ConnectedPersonalSpaceInternal);
